import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
    FacebookIcon,
    FacebookShareButton,
    WhatsappShareButton,
    WhatsappIcon,
    EmailShareButton,
    EmailIcon,
    TwitterShareButton,
    TwitterIcon,
} from 'react-share'
import * as shareStyle from './share.module.scss'

const Share = ({ url, size = 28, contentType = 'innehållet' }) => {
    const bgStyle = {
        fill: '#e07a5f',
    }

    const introTextClasses = classNames({
        [shareStyle.fineprint]: true,
        fineprint: true,
    })

    return (
        <div className={shareStyle.share}>
            <p className={introTextClasses}>Dela {contentType} med en vän</p>
            <FacebookShareButton url={url}>
                <FacebookIcon size={size} round={true} bgStyle={bgStyle} />
            </FacebookShareButton>
            <TwitterShareButton url={url}>
                <TwitterIcon size={size} round={true} bgStyle={bgStyle} />
            </TwitterShareButton>
            <WhatsappShareButton url={url}>
                <WhatsappIcon size={size} round={true} bgStyle={bgStyle} />
            </WhatsappShareButton>
            <EmailShareButton url={url}>
                <EmailIcon size={size} round={true} bgStyle={bgStyle} />
            </EmailShareButton>
        </div>
    )
}

Share.propTypes = {
    url: PropTypes.string.isRequired,
    size: PropTypes.number,
    contentType: PropTypes.string,
}

export default Share
